import { AxiosError } from 'axios';
import showNotification from 'utils/showNotification';
import { axiosAPI } from 'lib/api';
import { logInfo } from 'utils/logging';
import { getCSRFTOKEN } from 'utils/cookie/getCSRFToken';

type PostVoteAnswerResponse = {
  success: boolean;
  rating?: number;
};

const postVoteAnswer = async (id: number): Promise<PostVoteAnswerResponse> => {
  const csrf_token = getCSRFTOKEN('OTVETY-CSRF-TOKEN') || '';
  try {
    return await axiosAPI({
      url: `/otvety/api/answers/${id}/vote `,
      method: 'POST',
      headers: {
        'X-CSRF-TOKEN': csrf_token,
      },
    });
  } catch (error) {
    const e = error as AxiosError;
    showNotification('error', 'Произошла ошибка, повтори попытку позже');
    logInfo(e.toString(), true);
    return { success: false };
  }
};

export default postVoteAnswer;
